import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { take } from 'rxjs';
import { ROLE_CLAIM, Role } from 'src/app/models/user/role.model';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})

export class LoginComponent implements OnInit {
  constructor(private router: Router,
     private auth: AuthenticationService,
     private authService: AuthService,
    ) {}

  ngOnInit(): void {
    this.auth.user$
    .pipe(take(1))
    .subscribe(user => {
      if(!user)
      {
        this.auth.login();
        return;
      }

      const role: Role | undefined = user[ROLE_CLAIM];
      const isCallback = new URLSearchParams(window.location.search).has('code');

      if (isCallback) {
        this.authService.appState$.pipe(take(1)).subscribe(appState => {
          if (appState?.target && appState.target !== '/login') {
            this.router.navigateByUrl(appState.target);
          } else {
            this.redirect(role);
          }
        });
      } else {
        this.redirect(role);
      }
    });
  }

  redirect(role: Role | undefined){
    switch(role){
      case Role.Admin:
      case Role.SystemUser:
        this.router.navigate(['admin/dashboard']);
        break;
      case Role.Provider:
      case Role.Consultant:
      case Role.ProviderReadOnly:
        this.router.navigate(['provider/dashboard']);
        break;
      case Role.Lender:
      case Role.LenderReadOnly:
        this.router.navigate(['lender/dashboard']);
        break;
      default:
        this.auth.logout();
        break;
    }
  }

}
